import {
  CLIENT_IDENTIFIER_TYPE,
  CLIENT_RESULT_LIST,
  FETCH_CLIENT_LIST,
} from "constants/ActionTypes";

const INITIAL_STATE = {
  data: [],
  loading: false,
  clientList: [],
  clientIdentifierTypeList: [],
  clientResultList: [],
};

const ClientReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_CLIENT_LIST: {
      return {
        ...state,
        clientList: action.payload ? action.payload : [],
      };
    }
    case CLIENT_IDENTIFIER_TYPE: {
      return {
        ...state,
        clientIdentifierTypeList: action.payload,
      };
    }
    case CLIENT_RESULT_LIST: {
      return {
        ...state,
        clientResultList: action.payload,
      };
    }
    default:
      return state;
  }
};

export default ClientReducer;
